import React, { useEffect } from 'react';
import { useLocation } from 'react-router';

const RefundAndCancellationPolicy = () => {
    const location = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    return (
        <section>
            <div className="inn-body-section">
                <div className="container">
                    <div className="page-head">
                        <h2 style={{ 'fontSize': '33px' }}>Refund and Cancellation Policy</h2>
                        <div className="head-title">
                            <div className="hl-1"></div>
                            <div className="hl-2"></div>
                            <div className="hl-3"></div>
                        </div>
                        <p class="text-center"><strong>Effective Date:</strong> 01/05/2025</p>
                    </div>
                    <div className="content">
                        <div class="container my-5">
                            <strong class="mt-5">1. Purpose</strong>
                            <p>This Refund and Cancellation Policy outlines the terms and conditions under which residents and guests of Younic Home may request a refund following advance payment for accommodation.</p>

                            <strong class="mt-4">2. Scope</strong>
                            <p>This policy applies to:</p>
                            <ul>
                                <li><strong>Permanent Residents:</strong> Staying more than 4 months.</li>
                                <li><strong>Short-Term Guests:</strong> Staying up to 4 months, including stays as short as 1–7 days.</li>
                            </ul>

                            <strong class="mt-4">3. Advance Payment and Booking Confirmation</strong>
                            <ul>
                                <li>All residents and guests are required to pay an advance payment to confirm their booking.</li>
                                <li>Advance payments may include:
                                    <ul>
                                        <li>Monthly accommodation charges,</li>
                                        <li>Booking confirmation fees (non-refundable),</li>
                                        <li>Security deposits (if applicable).</li>
                                    </ul>
                                </li>
                            </ul>

                            <strong class="mt-4">4. Refund Policy for Permanent Residents (Stay &gt; 4 Months)</strong>
                            <p>If a Permanent Resident cancels their booking after making an advance payment, refunds will be issued according to the following schedule:</p>
                            <div class="table-responsive">
                                <table class="table table-bordered">
                                    <thead class="thead-light">
                                        <tr>
                                            <th>Time Since Payment</th>
                                            <th>Refund Percentage</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Within 1–2 days</td>
                                            <td>70% Refund</td>
                                        </tr>
                                        <tr>
                                            <td>Within 3–5 days</td>
                                            <td>50% Refund</td>
                                        </tr>
                                        <tr>
                                            <td>Within 6–7 days</td>
                                            <td>30% Refund</td>
                                        </tr>
                                        <tr>
                                            <td>After 7 days</td>
                                            <td>No Refund</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <strong>Conditions for Refund:</strong>
                            <ul>
                                <li>Time calculation starts from the date and time of payment.</li>
                                <li>Refund requests must be made in written format (official email, application, or authorized messaging platform).</li>
                                <li>Refunds will be processed within 10 (ten) working days after verification and approval.</li>
                                <li>Bank transaction fees and applicable charges will be deducted from the refundable amount.</li>
                                <li>The booking confirmation fee remains non-refundable under all circumstances.</li>
                            </ul>

                            <strong class="mt-4">5. Refund Policy for Short-Term Guests (Stay ≤ 4 Months)</strong>
                            <p>If a Short-Term Guest cancels their booking after making an advance payment, the following policy applies:</p>

                            <div class="table-responsive">
                                <table class="table table-bordered">
                                    <thead class="thead-light">
                                        <tr>
                                            <th>Cancellation Notification Time</th>
                                            <th>Refund Percentage</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Within 24 hours of payment</td>
                                            <td>50% Refund</td>
                                        </tr>
                                        <tr>
                                            <td>After 24 hours of payment</td>
                                            <td>No Refund</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <strong>Conditions for Refund:</strong>
                            <ul>
                                <li>The 24-hour calculation starts from the exact time of payment confirmation.</li>
                                <li>Refund requests must be submitted in written format.</li>
                                <li>Refunds will be processed within 10 (ten) working days after verification and approval.</li>
                                <li>Transaction fees, if any, will be deducted.</li>
                                <li>Booking confirmation fees are strictly non-refundable.</li>
                            </ul>

                            <strong class="mt-4">6. Non-Refundable Fees</strong>
                            <p>The following charges are strictly non-refundable under all circumstances:</p>
                            <ul>
                                <li>Booking confirmation fees,</li>
                                <li>Administrative service charges,</li>
                                <li>Late payment penalties (if applicable),</li>
                                <li>Promotional or discounted payments unless explicitly mentioned.</li>
                            </ul>

                            <strong class="mt-4">7. Special Cases (Exceptional Refund Consideration)</strong>
                            <p>Refunds outside the standard terms may be considered in the following cases:</p>
                            <ul>
                                <li>Severe medical emergency (proof required),</li>
                                <li>Visa rejection (for international residents, proof required),</li>
                                <li>Natural disasters officially declared,</li>
                                <li>Death of an immediate family member (proof required).</li>
                            </ul>
                            <p><strong>Note:</strong><br />
                                Supporting official documentation must be submitted.<br />
                                Approval remains solely at the discretion of Younic Home Management.
                            </p>

                            <strong class="mt-4">8. Force Majeure</strong>
                            <p>No refund or compensation will be provided if cancellation results from causes beyond the control of Younic Home, including but not limited to:</p>
                            <ul>
                                <li>Natural disasters (earthquake, flood, cyclone),</li>
                                <li>War, terrorism, political instability,</li>
                                <li>Governmental actions, lockdowns, or restrictions,</li>
                                <li>Pandemic or health emergencies.</li>
                            </ul>

                            <strong class="mt-4">9. Refund Procedure</strong>
                            <strong>Submission:</strong>
                            <p>Refund requests must be submitted in writing to the Younic Home Administration.</p>
                            <strong>Processing:</strong>
                            <p>Verified and eligible refunds will be processed within 10 (ten) working days.</p>
                            <strong>Payment Method:</strong>
                            <p>Refunds will be issued through the same mode of original payment, unless otherwise agreed.</p>
                            <strong>Deductions:</strong>
                            <p>Bank charges and applicable service fees will be deducted from the refundable amount.</p>

                            <strong class="mt-4">10. Abuse and Misuse of Policy</strong>
                            <ul>
                                <li>Younic Home reserves the right to:
                                    <ul>
                                        <li>Deny refunds if fraudulent or abusive cancellation behavior is suspected.</li>
                                        <li>Impose future booking restrictions for repeated cancellations without valid reason.</li>
                                    </ul>
                                </li>
                            </ul>

                            <strong class="mt-4">11. Policy Amendments</strong>
                            <ul>
                                <li>Younic Home reserves the right to amend, modify, or update this Refund and Cancellation Policy at any time.</li>
                                <li>Updated versions will be:
                                    <ul>
                                        <li>Displayed at the hostel office,</li>
                                        <li>Shared through official communication channels,</li>
                                        <li>Automatically applicable to all future and existing residents/guests after the date of publication.</li>
                                    </ul>
                                </li>
                            </ul>

                            <strong class="mt-4">12. Contact Information</strong>
                            <p>For all refund and cancellation inquiries, please contact:</p>
                            <ul class="list-unstyled">
                                <li>📞 <strong>Phone:</strong>  +8801325-051915, +8801711-704729</li>
                                <li>✉️ <strong>Email:</strong> info@younichostel.com</li>
                                <li>🕘 <strong>Office Hours:</strong> 9:00 AM – 6:00 PM (Saturday to Thursday)</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default RefundAndCancellationPolicy;
